import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Row from '../../../../core/layout/Row';
import Button from '../../../../core/form/Button';
import Select from '../../../../core/form/Select';
import Column from '../../../../core/layout/Column';
import TextInput from '../../../../core/form/TextInput';
import ColumnSeparator from '../../../../core/layout/ColumnSeparator';
import TranslationInputContainer from '../inputs/TranslationInputContainer';
import Table from '../../../../core/form/Table';
import Separator from '../../../../core/layout/Separator';
import ErrorText from '../../../../core/layout/ErrorText';

const ParagraphsInput = props => (
  <div>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Paragraph"
          fieldType="textarea"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'text', '')}
          onChange={value => props.onChange('text', value)}
          errorText={get(props.errors, 'text', '')}
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <TranslationInputContainer
          onChange={props.onChange}
          submitting={props.submitting}
          values={props.values}
          errors={props.errors}
          disabled={props.disabled}
        />
      </Column>
    </Row>
    <Row>
      <Column size={2}>
        <Select
          required
          label="Paragraph order"
          value={get(props.values, 'order')}
          onChange={value => props.onChange('order', value)}
          errorText={get(props.errors, 'order', '')}
          options={[1, 2, 3, 4, 5].map(option => ({
            value: option,
            label: option,
            disabled: !!props.paragraphs.find(
              paragraph => paragraph.order === option
            ),
          }))}
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <Button
          icon="check"
          type="primary"
          label={props.values.id ? 'Update' : 'Add'}
          disabled={!props.isDirty()}
          onClick={() => props.onSubmit()}
        />
        <ColumnSeparator size="xs" />
        <Button icon="reload" label="Discard" onClick={() => props.onReset()} />
      </Column>
    </Row>
    <Separator size="sm" />
    <Row>
      <Column size={12}>
        <Table
          columns={[
            {
              label: 'Paragraph',
              path: 'text',
              width: '350px',
            },
            {
              label: 'Order',
              path: 'order',
              width: '105px',
            },
            {
              label: 'Actions',
              path: 'action',
              width: '105px',
              render: (cell, row) => {
                if (!props.disabled) {
                  return (
                    <div>
                      <Button
                        icon="delete"
                        onClick={() => props.onDelete(row.id)}
                      />{' '}
                      <Button
                        icon="edit"
                        onClick={() => props.onEdit(row.id)}
                      />
                    </div>
                  );
                }
                return null;
              },
            },
          ]}
          rows={props.paragraphs}
        />
        {props.errorText && <ErrorText>{props.errorText}</ErrorText>}
      </Column>
    </Row>
  </div>
);

ParagraphsInput.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  errorText: PropTypes.string,
  submitting: PropTypes.bool,
  values: PropTypes.object,
  paragraphs: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  isDirty: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

ParagraphsInput.defaultProps = {
  label: 'Add',
  errorText: null,
  disabled: false,
  value: {},
  paragraphs: [],
};

export default ParagraphsInput;
